import { getTeamLabel } from './teamLabels'

// Team options for the Fixtures filter and the add-fixture form, taken from the
// squads' own team settings (up to 5 teams) plus any team numbers already used by fixtures.
export function getTeamOptions(squads, squadFilter, fixtures) {
  const inScope = squadFilter === 'all' ? squads : squads.filter(s => s.id === squadFilter)
  const scopeIds = new Set(inScope.map(s => s.id))
  const numbers = new Set()
  inScope.forEach(s => (s.squad_teams || []).forEach(t => numbers.add(Number(t.team_number))))
  fixtures.filter(f => scopeIds.has(f.squad_id)).forEach(f => numbers.add(Number(f.team_number || 1)))
  if (numbers.size === 0) numbers.add(1)
  return [...numbers].sort((a, b) => a - b).map(n => {
    const owner = inScope.find(s => (s.squad_teams || []).some(t => Number(t.team_number) === n)) || inScope[0]
    return { value: String(n), label: getTeamLabel(n, owner?.squad_teams) }
  })
}

export function getSportOptions(fixtures) {
  return [...new Set(fixtures.map(f => f.sport).filter(Boolean))].sort().map(sp => ({
    value: sp,
    label: sp === 'hurling' ? 'Hurling' : sp === 'camogie' ? 'Camogie' : 'Football',
  }))
}